module.exports = __webpack_public_path__ + "img/arrow.347b633f.webp";